import * as React from "react";
import type { SVGProps } from "react";
const SvgAiSparklesGradient = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    viewBox="0 0 33 33" {...props}
  >
    <path
      fill="url(#ai-sparkles-gradient_svg__a)"
      d="M16.334 2.72a.68.68 0 0 1 .655.498l2.152 8.35a2.72 2.72 0 0 0 1.956 1.955l8.35 2.153a.68.68 0 0 1 0 1.312l-8.35 2.152a2.72 2.72 0 0 0-1.956 1.956l-2.154 8.35a.68.68 0 0 1-1.31 0l-2.152-8.35a2.72 2.72 0 0 0-1.956-1.956l-8.35-2.154a.68.68 0 0 1 0-1.31l8.35-2.153a2.72 2.72 0 0 0 1.956-1.955l2.154-8.35a.68.68 0 0 1 .655-.497M5.444 21.776c.752 0 1.361.61 1.362 1.362v.002l.14.006a1.361 1.361 0 0 1 0 2.709l-.14.007a1.36 1.36 0 0 1-2.723 0l-.139-.008a1.361 1.361 0 0 1 0-2.708l.139-.006v-.002c0-.752.61-1.361 1.361-1.362M27.222 2.722c.751 0 1.361.61 1.361 1.361v1.36h1.361a1.362 1.362 0 0 1 0 2.722h-1.361v1.362a1.361 1.361 0 0 1-2.723 0V8.165H24.5a1.361 1.361 0 0 1 0-2.723h1.36V4.083c0-.752.61-1.361 1.362-1.361"
    />
    <defs>
      <linearGradient
        id="ai-sparkles-gradient_svg__a"
        x1={-1.531}
        x2={42.187}
        y1={34.153}
        y2={1.893}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAiSparklesGradient;
